import Vue from "vue";

import _, {get} from 'lodash'

enum Arch {
    AMD = 'amd',
    ARM = 'arm',
    GPU = 'gpu',
    x86 = 'x86'
}

interface IProductType {
    id: number
    name: string
    desc?: string[] // 机型描述，创建页使用
    arch: Arch,
    isVirtualGPU?: boolean //arch里只有gpu，是否vGPU通过这个字段区分

    // 原代码中的注释是"通用型主机 注：不支持本地数据盘"
    // 目前梳理的结果是 只支持ebs，不支持本地盘（系统盘&数据盘）
    // 暂时不做调整，避免出现问题
    onlyEbs?: boolean

    // 源代码的注释是"// 数据盘同时支持EBS和本地盘"
    // 目前梳理的结果是 系统盘&数据盘都支持EBS和本地盘两种情况
    // 特例是I4（357），之前把I4同时放在commonModelTypeCodes和is2dataDiskTypeCodes两种情况里，
    // 然后在commonModelTypeCodes的时候，判断一下I4是否选择了ebs，这个其实不严谨
    multiDiskType?: boolean


    // 可变系统盘
    // 目前来看，所有机型都支持可变系统盘了。以后是否存在不可变的情况暂时不知道，先保留这个字段
    adjustSystemDisk?: boolean

    //是否在新建实例的时候支持加入容灾组
    supportAvoid?: boolean
}

// let commonModelTypeCodes = [40, 137, 151, 198, 347, 348, 377, 326, 357, 430, 401, 508, 548, 547, 597, 595];
// let is2dataDiskTypeCodes = [78, 110, 152, 138, 187, 101, 77, 125, 142, 303, 305, 111, 321, 357, 388];
// let adjustTypeCodes = [40, 41, 45, 42, 46, 78, 79, 138, 137, 151, 143, 198, 303, 305, 326, 353, 152, 110, 111, 187, 347, 348,
// 377, 357, 388, 142, 321, 77, 101, 125, 430, 401, 508, 548, 547, 298, 597, 595];


const productTypes: IProductType[] = [{
    id: 40,
    arch: Arch.x86,
    name: Vue.$trans(`通用型N1`),//'通用型N1',
    desc: [Vue.$trans(`适合各个行业通用计算需求，如：小型 Web 应用、中小型数据等。`)],
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 41,
    arch: Arch.x86,
    name: Vue.$trans(`IO优化型I1`),//'IO优化型I1',
    desc: [Vue.$trans(`IO优化型I1实例是高磁盘IO的最佳选择，提供每秒数万次低延迟性随机 操作（IOPS）。`), Vue.$trans(`适合于低延时、I/O密集型应用。`)],
    adjustSystemDisk: true,
}, {
    id: 42,
    arch: Arch.x86,
    name: Vue.$trans(`计算优化型C1`),//'计算优化型C1',
    desc: [Vue.$trans(`采用Intel Xeon E5-2680 v3 （Haswell） 处理器，2.5GHz的主频，DDR4内存。`), Vue.$trans(`建议用于游戏服务器、数据库服务器。`)],
    adjustSystemDisk: true,
}, {
    id: 43, // 存储优化型主机?
    arch: Arch.x86,
    name: '',
    desc: [Vue.$trans(`存储优化型`)],
}, {
    id: 45,
    arch: Arch.x86,
    name: Vue.$trans(`IO优化型I1（联网增强）`), //IO优化型I1（联网增强）
    desc: [Vue.$trans(`IO优化型I1联网增强实例是高磁盘IO的最佳选择，提供每秒数万次低延迟性随机 操作（IOPS）。`), Vue.$trans(`适合于对实时性要求较高的视频直播、即时通讯、房间式强联网网游等应用场景。`)],
    adjustSystemDisk: true,
}, {
    id: 46,
    arch: Arch.x86,
    name: Vue.$trans(`计算优化型C1（联网增强）`),  //计算优化型C1（联网增强）
    desc: [Vue.$trans(`采用Intel Xeon E5-2680 v3 （Haswell） 处理器，2.5GHz的主频，DDR4内存。`), Vue.$trans(`对实时性要求较高的视频直播、即时通讯、房间式强联网网游等应用场景。`)],
    adjustSystemDisk: true,
}, {
    id: 77,
    arch: Arch.GPU,
    name: Vue.$trans(`GPU通用计算型（P3）`),//'GPU通用计算型(P3)',
    desc: [Vue.$trans(`GPU通用计算型（P3）实例使用NVIDIA P40 型GPU加速卡单卡拥有12TFlops的单精度浮点运算能力和24GB显存。`), Vue.$trans(`可以用于深度学习的训练与推理预测场景，也可以用于其他通用计算加速场景。`)],
    multiDiskType: true,
    adjustSystemDisk: true,
    supportAvoid: false,
}, {
    id: 78,
    arch: Arch.x86,
    name: Vue.$trans(`IO优化型I2`), //'IO优化型I2',
    desc: [Vue.$trans(`采用Intel Xeon E5-2690 v4 （Broadwell） 处理器，2.6GHz的高主频，DDR4内存。`), Vue.$trans(`IO优化型I2实例是高磁盘IO的最佳选择，提供每秒数万次低延迟性随机 I/O 操作（IOPS）。`), Vue.$trans(`适合于低延时、I/O密集型应用，建议用于游戏服务器、数据库服务器。`)],
    multiDiskType: true,
    adjustSystemDisk: true,
}, {
    id: 79,
    arch: Arch.x86,
    name: Vue.$trans(`IO优化型I2（联网增强）`), //IO优化型I2（联网增强）
    desc: [Vue.$trans(`采用Intel Xeon E5-2690 v4 （Broadwell） 处理器，2.6GHz的高主频，DDR4内存。`), Vue.$trans(`IO优化型I2联网增强实例是高磁盘IO的最佳选择，提供每秒数万次低延迟性随机 I/O 操作（IOPS）。`), Vue.$trans(`适合于对实时性要求较高的视频直播、即时通讯、房间式强联网网游等应用场景。`)],
    adjustSystemDisk: true,
}, {
    id: 80, // unknown???   c2 ???
    arch: Arch.x86,
    name: '',
    desc: [Vue.$trans(`采用Intel Xeon E5-2667 v4 （Broadwell） 处理器，3.2GHz的超高主频，DDR4内存。`), Vue.$trans(`计算优化型C2实例是高计算性能和高并发读写的应用的最佳选择。`), Vue.$trans(`建议用于大型游戏服务器、高性能计算以及其他计算密集型应用。`)],
}, {
    id: 101,
    arch: Arch.GPU,
    name: Vue.$trans(`GPU推理计算型（P3I）`),//'GPU推理计算型(P3I)',
    desc: [Vue.$trans(`GPU推理计算型P3I实例使用NVIDIA P4 型GPU加速卡，拥有单卡5.6TFlops的单精度浮点运算能力和8GB显存。`), Vue.$trans(`可以用于深度学习的推理场景，被称为推理加速器，也可以结合GRID方案，用于桌面渲染。`)],
    multiDiskType: true,
    adjustSystemDisk: true,
    supportAvoid: false,
}, {
    id: 110,
    arch: Arch.x86,
    name: Vue.$trans(`IO优化型I3`), //'IO优化型I3',
    desc: [Vue.$trans(`2.7 GHz Intel Xeon® Platinum 8168 处理器，DDR4内存。`), Vue.$trans(`高磁盘 IO 负载，低延迟高吞吐`), Vue.$trans(`适用于MMOGPG、MOBA游戏前端等场景`)],
    multiDiskType: true,
    adjustSystemDisk: true,
}, {
    id: 111,
    arch: Arch.x86,
    name: Vue.$trans(`计算优化型C3`),//'计算优化型C3',
    desc: [Vue.$trans(`3.2 GHz Intel Xeon® Gold 6146  处理器，睿频高达3.6 GHz。DDR4内存。`), Vue.$trans(`高计算性能和高并发读写`), Vue.$trans(`适用于高负载数据库、高负载web等场景`)],
    multiDiskType: true,
    adjustSystemDisk: true,
}, {
    id: 125,
    arch: Arch.GPU,
    name: Vue.$trans(`GPU通用计算型（P4V）`),//'GPU通用计算型(P4V)',
    desc: [Vue.$trans(`GPU通用计算型P4V使用NVIDIA V100型加速卡，拥有单卡15TFLOPS单精度浮点运算能力以及125TFLOPS混合精度矩阵运算能力，16GB显存，使深度学习训练与推理过程有3X倍性能提升`)],
    multiDiskType: true,
    adjustSystemDisk: true,
    supportAvoid: false,
}, {
    id: 126,
    arch: Arch.GPU,
    name: Vue.$trans(`GPU图形计算型（G1）`),//'GPU图形计算型(G1)',
    desc: [Vue.$trans(`GPU图形计算型P4V使用AMD S7150型加速卡，拥有单卡3.77TFLOPS单精度浮点运算能力以及250 GFLOPS双精度浮点运算能力，8GB显存。`), Vue.$trans(`能够轻松加速应用程序和处理复杂的计算工作流,适用于远程图形工作站、云游戏，云计算、VDI等虚拟领域使用场景。`)],
    supportAvoid: false,
}, {
    id: 137,
    arch: Arch.x86,
    name: Vue.$trans(`通用型N2`), //'通用型N2',
    desc: [Vue.$trans(`2.6GHz Intel Xeon E5-2690 v4 处理器，DDR4内存`), Vue.$trans(`适合中小规模的企业级应用，数据库、缓存、搜索集群，以及中小型Web应用、手机应用等对资源没有特殊要求场景。`)],
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 138,
    arch: Arch.x86,
    name: Vue.$trans(`性能保障型X2`), //'性能保障型X2',
    desc: [Vue.$trans(`2.6 GHz Intel Xeon E5-2690 v4 处理器，DDR4内存`), Vue.$trans(`高磁盘 IO 负载，低延迟高吞吐`), Vue.$trans(`适用于高负载web服务及需要低时延的I/O密集型应用`)], //x2机型描述信息
    multiDiskType: true,
    adjustSystemDisk: true,
}, {
    id: 142,
    arch: Arch.GPU,
    name: Vue.$trans(`GPU推理计算型（P3IN）`),//'GPU推理计算型(P3IN)'
    desc: [Vue.$trans(`GPU推理计算型P3IN使用NVIDIA P4型加速卡，拥有单卡5.6TFLOPS单精度浮点运算能力和8GB显存`), Vue.$trans(`可以用于深度学习的推理场景，被称为推理加速器，也可以结合GRID方案，用于桌面渲染。`)],
    multiDiskType: true,
    adjustSystemDisk: true,
    supportAvoid: false,
}, {
    id: 143,
    arch: Arch.x86,
    name: '', // 专属虚机2.0 ???
    adjustSystemDisk: true,
    supportAvoid: false
}, {
    id: 151,
    arch: Arch.x86,
    name: Vue.$trans(`通用型N3`), //'通用型N2',
    desc: [Vue.$trans(`2.7 GHz Intel Xeon® Platinum 8168 处理器，DDR4内存`), Vue.$trans(`平衡的计算、内存和网络资源`), Vue.$trans(`适用于各种类型和规模的企业级应用等场景。`)], //通用型N3描述信息
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 152,
    arch: Arch.x86,
    name: Vue.$trans(`标准型S3`), //'标准型S3',
    desc: [Vue.$trans(`2.6 GHz Intel Xeon® Gold 6132 处理器，DDR4内存`), Vue.$trans(`平衡的计算、内存和网络资源`), Vue.$trans(`适用于各种类型和规模的企业级应用及数据库等场景`)], //s3机型描述信息
    multiDiskType: true,
    adjustSystemDisk: true,
}, {
    id: 187,
    arch: Arch.x86,
    name: Vue.$trans(`标准网络型SN3`), //标准网络型SN3
    desc: [Vue.$trans(`2.6 GHz Intel Xeon® Gold 6132 处理器，DDR4内存`), Vue.$trans(`提供平衡的计算、内存和网络资源、支持IPV6网络`), Vue.$trans(`适用于各种类型和规模的企业级应用及数据库等场景。`)], //标准网络型SN3
    multiDiskType: true,
    adjustSystemDisk: true,
}, {
    id: 192,
    arch: Arch.x86,
    name: Vue.$trans(`容器实例型`)
}, {
    id: 198,
    arch: Arch.AMD,
    name: Vue.$trans(`标准型SA1`), //'标准型SA1',
    desc: [Vue.$trans(`2.0GHz AMD EPYC™ 7551 处理器，DDR4内存。`), Vue.$trans(`平衡的计算、内存和网络资源，超高性价比。`), Vue.$trans(`适用各种类型和规模的企业级应用。`)], //标准型SA1
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 298,
    arch: Arch.x86,
    name: Vue.$trans(`标准型S1`), //'标准型S1'
    desc: [Vue.$trans(`标准型S1是高磁盘IO的最佳选择`), Vue.$trans(`提供每秒数万次低延迟性随机操作（ IOPS）`)], //标准型S1
    adjustSystemDisk: true,
}, {
    id: 303,
    arch: Arch.x86,
    name: Vue.$trans(`基础型E1`), //'基础型E1',
    desc: [Vue.$trans(`Intel Xeon CPU E5处理器，DDR3内存。`), Vue.$trans(`平衡的计算、内存和网络资源，超高性价比。`), Vue.$trans(`适用于大中小型应用、大中小型数据库等不同应用。`)], //基础型E1描述信息
    multiDiskType: true,
    adjustSystemDisk: true,
}, {
    id: 305,
    arch: Arch.ARM,
    name: Vue.$trans(`ARM计算型AC1`), //'ARM计算型AC1'
    desc: [Vue.$trans(`搭载ARM处理器，具备高计算效能。`), Vue.$trans(`适用于对安全隐私要求较高的政企、金融等业务场景。`)], //ARM计算型AC1
    multiDiskType: true,
    adjustSystemDisk: true,
}, {
    id: 321,
    arch: Arch.GPU,
    isVirtualGPU: true,
    name: Vue.$trans(`GPU虚拟型（vGN5）`), //'GPU虚拟型(vGN5)',
    desc: [Vue.$trans(`GPU虚拟化型vGN5实例针对NVIDIA P4 GPU加速卡进行虚拟化，提供更加细粒度的GPU计算能力，不同license对应的虚拟GPU提供侧重点不同的计算能力。`), Vue.$trans(`vCS license类型的vGPU可以用于小规模推理和简单的神经网络训练场景。`)], //GPU虚拟化(vGN5)
    multiDiskType: true,
    adjustSystemDisk: true,
    supportAvoid: false,
}, {
    id: 326,
    arch: Arch.GPU,
    name: Vue.$trans(`GPU推理Ⅱ型（GN6I）`), //'推理Ⅱ型(GN6I)',
    desc: [Vue.$trans(`Nvidia Tesla T4卡，拥有8.1TFLOPS，16GB显存`), Vue.$trans(`具备强大的计算性能，可用于实时推理和简单的模型训练、图形图像处理等场景`)], //GPU虚拟型(GN6I)
    onlyEbs: true,
    adjustSystemDisk: true,
    supportAvoid: false,
}, {
    id: 347,
    arch: Arch.x86,
    name: Vue.$trans(`计算优化型C4`), //'计算优化型C4'，
    desc: [Vue.$trans(`3.10GHz Intel® Xeon® Gold 6242R 处理器，最新六通道DDR4`), Vue.$trans(`高计算性能和高并发读写`), Vue.$trans(`适用于高负载数据库、视频编码、高负载Web等场景`)], //计算优化型C4
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 348,
    arch: Arch.x86,
    name: Vue.$trans(`标准型S4`), //'标准型S4'，
    desc: [Vue.$trans(`2.60GHz Intel® Xeon® Gold 6240 处理器，最新六通道DDR4`), Vue.$trans(`平衡的计算、内存和网络资源`), Vue.$trans(`适用于各种类型和规模的企业级应用等场景`)],
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 652,
    arch: Arch.AMD,
    name: Vue.$trans(`标准型A6`), //'标准型A6'，
    desc: [Vue.$trans(`2.60GHz AMD EYPC™ Milan 7513 处理器，最新八通道DDR4`), Vue.$trans(`每一个vCPU都对应一个AMD EYPC™处理器核心的超线程，性能强劲稳定`), Vue.$trans(`适用于搜索等计算集群、视频编解码、游戏服务器及其他通用类型的企业级应用`)],
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 353,
    arch: Arch.GPU,
    name: Vue.$trans(`GPU通用计算型（P3L）`), //'GPU通用计算型(P3L)',
    adjustSystemDisk: true,
    supportAvoid: false,
    // desc: null
}, {
    id: 357,
    arch: Arch.x86,
    name: Vue.$trans(`IO优化型I4`), //'IO优化型I4',
    desc: [Vue.$trans(`2.60GHz Intel® Xeon® Gold 6240 处理器，最新六通道DDR4`), Vue.$trans(`NVMe SSD本地盘，提供极致吞吐和IO性能`), Vue.$trans(`适用于高性能关系型数据库、NoSQL数据库等场景`)], //IO优化型I4
    //--- todo: I4很特殊，同时支持两种盘的判断，应该改掉。。。
    onlyEbs: true,
    multiDiskType: true,
    adjustSystemDisk: true,
}, {
    id: 377,
    arch: Arch.GPU,
    isVirtualGPU: true,
    name: Vue.$trans(`GPU虚拟型（vGN6）`), //'GPU虚拟型(vGN6)',
    desc: [Vue.$trans(`GPU虚拟化vGN6实例针对NVIDIA T4 GPU加速卡进行虚拟化，提供更加细粒度的GPU计算能力。`), Vue.$trans(`vCS类型可以用于小规模训练推理，vPC类型可以用于图像渲染等处理。`)], //GPU虚拟型(vGN6)
    onlyEbs: true,
    adjustSystemDisk: true,
    supportAvoid: false,
}, {
    id: 388,
    arch: Arch.ARM,
    name: Vue.$trans(`ARM计算型AC2`), //'ARM计算型AC2'
    desc: [Vue.$trans(`搭载鲲鹏920处理器，提供平衡的计算、内存和网络资源`), Vue.$trans(`满足政府、军工等各类企业高性价比、安全隐私高的业务场景`)], //ARM计算型AC2
    multiDiskType: true,
    adjustSystemDisk: true,
}, {
    id: 401,
    arch: Arch.ARM,
    name: Vue.$trans(`ARM计算型FC1`), //'ARM计算型FC1'
    desc: [Vue.$trans(`搭载FT-2000+处理器，提供平衡的计算、内存和网络资源`), Vue.$trans(`满足政府、军工等各类企业高性价比、安全隐私高的业务场景`)], //ARM计算型FC1
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 430,
    arch: Arch.x86,
    name: Vue.$trans(`大数据型D4`), //'大数据型D4'
    desc: [Vue.$trans(`最新一代大数据机型实例，提供高吞吐本地存储资源`), Vue.$trans(`适合 Hadoop 分布式计算、并行数据处理等吞吐密集型业务使用`)], //大数据型D4
    onlyEbs: true,
    adjustSystemDisk: true,
// }, {
//     id: 498,
//     arch: Arch.x86,
//     name: Vue.$trans(`标准IO优化型S4E`),
//     desc: [Vue.$trans(`2.60GHz Intel® Xeon® Gold 6240 处理器，最新六通道DDR4`), Vue.$trans(`搭配极速型ESSD云盘，提供极致吞吐和IO性能`), Vue.$trans(`适用于高性能关系型数据库、NoSQL数据库等场景`)], //标准IO优化型S4E
//     onlyEbs: true,
//     adjustSystemDisk: true,
}, {
    id: 641,
    arch: Arch.x86,
    name: Vue.$trans(`大数据型D6`), //'大数据型D6'
    desc: [Vue.$trans(`2.60GHz Intel® Xeon® Gold 6240 处理器，最新六通道DDR4`), Vue.$trans(`每一个vCPU都对应一个Intel ® Xeon ®处理器核心的超线程，性能强劲稳定`), Vue.$trans(`适用于各种类型和规模的企业级应用等场景`)], //大数据型D6
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 508,
    arch: Arch.x86,
    name: Vue.$trans(`性能保障型X5`), //'性能保障型X5'
    desc: [Vue.$trans(`2.60GHz Intel® Xeon® Gold 6240 处理器，最新六通道DDR4`), Vue.$trans(`每一个vCPU都对应一个Intel ® Xeon ®处理器核心的超线程，性能强劲稳定`), Vue.$trans(`适用于各种类型和规模的企业级应用等场景`)], //性能保障型X5
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 517,
    arch: Arch.x86,
    name: Vue.$trans(`专属型3.0`),
    supportAvoid: false,
}, {
    id: 547,
    arch: Arch.x86,
    name: Vue.$trans(`性能保障型X6`), //'性能保障型X6'
    desc: [Vue.$trans(`2.60GHz Intel®Xeon®Platinum 8358P（Icelake） 处理器，最新八通道DDR4`), Vue.$trans(`每一个vCPU都对应一个Intel ® Xeon ®处理器核心的超线程，性能强劲稳定`), Vue.$trans(`适用于各种类型和规模的企业级应用等场景`)], //性能保障型X6
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 548,
    arch: Arch.x86,
    name: Vue.$trans(`计算优化型C5`), //'计算优化型C5'
    desc: [Vue.$trans(`3.10GHz Intel® Xeon® Gold 6242R 处理器，最新六通道DDR4`), Vue.$trans(`每一个vCPU都对应一个Intel ® Xeon ®处理器核心的超线程，性能强劲稳定`), Vue.$trans(`适用于各种类型和规模的企业级应用等场景`)], //计算优化型C5
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 595,
    arch: Arch.x86,
    name: Vue.$trans(`标准型S6`),
    desc: [Vue.$trans(`2.60GHz Intel®Xeon®Platinum 8358P（Icelake） 处理器，最新八通道DDR4`), Vue.$trans(`平衡的计算、内存和网络资源`), Vue.$trans(`适用于各种类型和规模的企业级应用等场景`)], //标准型S6
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 597,
    arch: Arch.GPU,
    name: Vue.$trans(`GPU推理I型（GN5I）`), //'GPU推理I型(GN5I)'
    desc: [Vue.$trans(`Nvidia Tesla P4 GPU加速卡，拥有5.6TFlops的单精度浮点运算能力，8GB显存`), Vue.$trans(`可用于深度学习的推理场景，被称为推理加速器，也可以结合GRID方案，用于图像渲染等`)], //GPU推理I型(GN5I)
    onlyEbs: true,
    adjustSystemDisk: true,
    supportAvoid: false
}, {
    id: 603,
    arch: Arch.GPU,
    name: Vue.$trans(`GPU专属型`),
    supportAvoid: false,
}, {
    id: 627,
    arch: Arch.x86,
    name: Vue.$trans(`性能保障型X6H`), //'性能保障型X6H'
    desc: [Vue.$trans(`2.60GHz Intel®Xeon®Platinum 8358P（Icelake） 处理器，最新八通道DDR4`), Vue.$trans(`平衡的计算、内存和网络资源`), Vue.$trans(`适用于各种类型和规模的企业级应用等场景`)], //性能保障型X6H
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 628,
    arch: Arch.x86,
    name: Vue.$trans(`极速云盘型X6E`), //极速云盘型X6E ==== 也划分在性能保障型分类里
    desc: [Vue.$trans(`2.60GHz Intel®Xeon®Platinum 8358P（Icelake） 处理器，最新八通道DDR4`), Vue.$trans(`每一个vCPU都对应一个Intel ® Xeon ®处理器核心的超线程，性能强劲稳定`), Vue.$trans(`支持挂载极速云盘，适用于大型数据库等各类企业级应用场景`)],
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 647,
    arch: Arch.x86,
    name: Vue.$trans(`内存型R6`),
    desc: [Vue.$trans(`2.60GHz Intel®Xeon®Platinum 8358P（Icelake） 处理器，最新八通道DDR4`), Vue.$trans(`每一个vCPU都对应一个Intel ® Xeon ®处理器核心的超线程，性能强劲稳定`), Vue.$trans(`适用于各种类型和规模的企业级应用等场景`)],
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 656,
    arch: Arch.x86,
    name: Vue.$trans(`星河云服务器`), 
    desc: [Vue.$trans(`新一代超高性价比云盘机型，提供平衡的计算、内存和网络资源`), Vue.$trans(`适用于中小型应用、中小型数据库等不同场景`)],
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 661,
    arch: Arch.GPU,
    name: Vue.$trans(`GPU高效计算型（P5V）`),//GPU高效计算型（P5V）,
    desc: [Vue.$trans(`NVIDIA GM301 GPU卡，拥有19.5TFLOPS，80G显存`), Vue.$trans(`可用于深度学习 、高性能数据分析和高性能计算应用场景。深度学习，例如：对象检测、无人驾驶、语音翻译识别等人工智能算法训练；高性能数据分析和高性能计算，例如石油勘探、生命科学、气象环境分析等场景。`)],
    onlyEbs: true,
    adjustSystemDisk: true,
    supportAvoid: false
}, {
    id: 651,
    arch: Arch.x86,
    name: Vue.$trans(`网络增强型X6N`), 
    desc: [Vue.$trans(`2.60GHz Intel®Xeon®Platinum 8358P（Icelake） 处理器，最新八通道DDR4`), Vue.$trans(`每一个vCPU都对应一个Intel ® Xeon ®处理器核心的超线程，性能强劲稳定`), Vue.$trans(`适用于网络密集型应用场景，例如直播、视频弹幕、游戏等应用场景`)],
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 668,
    arch: Arch.x86,
    name: Vue.$trans(`IO优化型I6`),
    desc: [Vue.$trans(`2.60GHz Intel®Xeon®Platinum 8358P（Icelake） 处理器，最新八通道DDR4`), Vue.$trans(`高磁盘 IO 负载，低延迟高吞吐`), Vue.$trans(`适用于MMOGPG、MOBA游戏前端等场景
    `)],
    onlyEbs: true,
    multiDiskType: true,
    adjustSystemDisk: true,
}, {
    id: 650,
    arch: Arch.x86,
    name: Vue.$trans(`性能增强型X6S`),
    desc: [Vue.$trans(`Intel®Xeon®️IceLake系列处理器，最新八通道DDR4`), Vue.$trans(`每一个vCPU都对应一个Intel ® Xeon ®处理器核心的超线程，性能强劲稳定`), Vue.$trans(`适用于网络密集型应用场景，例如直播、视频弹幕、游戏等应用场景`)],
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 687,
    arch: Arch.x86,
    name: Vue.$trans(`性能保障型X7`), //'性能保障型X7'
    desc: [Vue.$trans(`2.70GHz Intel®Xeon®Platinum 8458P（Sapphire Rapids） 处理器`), Vue.$trans(`每一个vCPU都对应一个Intel ® Xeon ®处理器核心的超线程，性能强劲稳定`), Vue.$trans(`主要适用于计算密集型应用场景，例如游戏、数据库、直播等应用场景。`)],
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 690,
    arch: Arch.GPU,
    name: Vue.$trans(`GPU通用计算型GN7I`),
    desc: [Vue.$trans(`NVIDIA A10 Tensor核心GPU`), Vue.$trans(`基于NVIDIA Ampere架构，拥有24GB GDDR6显存，31.2 TFLOPS，250 INT8 TOPS，500 INT4 TOPS`), Vue.$trans(`主要适用于大规模AI推理，小规模训练，图形图像处理等处理业务。`)],
    onlyEbs: true,
    adjustSystemDisk: true,
    supportAvoid: false
}, {
    id: 710,
    arch: Arch.ARM,
    name: Vue.$trans(`ARM计算型AC4`),
    desc: [Vue.$trans(`2.60GHz 鲲鹏920处理器，搭配更新的云盘和网络配置，获得性价比更好的体验。`), Vue.$trans(`适用于各种类型政府、互联网等各类企业对云上业务高性价比、安全可靠等场景。`)],
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 712,
    arch: Arch.x86,
    name: Vue.$trans(`计算优化型C7`),
    desc: [Vue.$trans(`3.10GHz Intel®Xeon®Platinum Sapphire Rapids 处理器。`), Vue.$trans(`每一个vCPU都对应一个Intel ® Xeon ®处理器核心的超线程，性能强劲稳定。`), Vue.$trans(`主要适用于高主频计算密应用场景，例如游戏、数据分析、科学工程应用等应用场景。`)],
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 714,
    arch: Arch.x86,
    name: Vue.$trans(`弹性裸金属EPCX7L`),
    desc: [Vue.$trans('2.70GHz Intel®Xeon®Platinum 8458P（Sapphire Rapids） 处理器'), Vue.$trans('搭载DPU BlueField-2的星曜弹性裸金属机型，计算性能与传统物理机无差别，同时具有安全物理隔离、无资源争抢的特点。'), Vue.$trans('主要适用于对资源独享、安全隔离、性能有较高要求的业务场景，如容器、数据库、企业核心业务、大数据计算等。')],
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 713,
    arch: Arch.x86,
    name: Vue.$trans(`弹性裸金属EPCX7`),
    desc: [Vue.$trans('2.70GHz Intel®Xeon®Platinum 8458P（Sapphire Rapids） 处理器'), Vue.$trans('搭载DPU BlueField-3的星曜弹性裸金属机型，计算性能与传统物理机无差别，同时具有安全物理隔离、无资源争抢的特点。'), Vue.$trans('主要适用于对资源独享、安全隔离、性能有较高要求的业务场景，如容器、数据库、企业核心业务、大数据计算等。')],
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 729,
    arch: Arch.x86,
    name: Vue.$trans(`性能保障型X8`),
    desc: [Vue.$trans(`2.70GHz Intel®Xeon®Platinum 8558P（Sapphire Rapids） 处理器`), Vue.$trans(`每一个vCPU都对应一个Intel ® Xeon ®处理器核心的超线程，性能强劲稳定`), Vue.$trans(`主要适用于计算密集型应用场景，例如游戏、数据库、直播等应用场景。`)],
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 731,
    arch: Arch.x86,
    name: Vue.$trans(`专属型NI6`),
    desc: [Vue.$trans(`2.60GHz Intel®Xeon®Platinum 8358P（Icelake） 处理器，最新八通道DDR4`), Vue.$trans(`每一个vCPU都对应一个Intel ® Xeon ®处理器核心的超线程，性能强劲稳定`), Vue.$trans(`适用于各种类型和规模的企业级应用等场景。`)],
    onlyEbs: true,
    adjustSystemDisk: true,
}, {
    id: 162006,
    arch: Arch.x86,
    name: Vue.$trans(`高效型SE9`),
    desc: [Vue.$trans(`1.9GHz Intel®Xeon®Platinum 6766E 处理器`), Vue.$trans(`每一个vCPU都对应一个Intel  Xeon 处理器核心的超线程，性能均衡稳定。`), Vue.$trans(`主要适用于数据库、容器和微服务引擎、高网络收发包等应用场景。`)],
    onlyEbs: true,
    adjustSystemDisk: true,
}]


// console.log(productTypes.length, 'productTypes')

const productTypeMap: { [productTypeId: number]: IProductType } = {};
// 初始化map 提高查询效率
productTypes.forEach(item => {
    productTypeMap[item.id] = item;
})

export const getKecTypeLocaleDescByTypeId = (typeId: number): string[] | undefined => {
    return get(productTypeMap[typeId], 'desc');
}

export const getProductTypeLocaleTitleById = (productTypeId: number): string | undefined => {
    return get(productTypeMap[productTypeId], 'name');
}

export const getArchById = (productTypeId: number): string => {
    // 默认为x86机型
    return get(productTypeMap[productTypeId], 'arch', Arch.x86);
}

export const isGPU = (productTypeId: number): boolean => {
    return get(productTypeMap[productTypeId], 'arch') === Arch.GPU;
}

export const isCommonModelType = (productTypeId: number): boolean => {
    return get(productTypeMap[productTypeId], 'onlyEbs') === true;
}
export const is2dataDiskType = (productTypeId: number): boolean => {
    return get(productTypeMap[productTypeId], 'multiDiskType') === true;
}
export const isAdjustSysDiskType = (productTypeId: number): boolean => {
    return get(productTypeMap[productTypeId], 'adjustSystemDisk') === true;
}

export const isSupportAvoid = (productTypeId: number): boolean => {
    return get(productTypeMap[productTypeId], 'supportAvoid') !== false;
}
